export var ActorRenderMode;
(function (ActorRenderMode) {
    ActorRenderMode["VTK_IMAGE"] = "vtkImage";
    ActorRenderMode["VTK_VOLUME"] = "vtkVolume";
    ActorRenderMode["VTK_VOLUME_SLICE"] = "vtkVolumeSlice";
    ActorRenderMode["CPU_IMAGE"] = "cpuImage";
    ActorRenderMode["CPU_VOLUME"] = "cpuVolume";
})(ActorRenderMode || (ActorRenderMode = {}));
